import { createFileRoute, redirect } from "@tanstack/react-router";

import { parseSemanticSearch } from "../../../workspaces/library/pages/semantic-search";

/* Search moments became Search; a link someone kept to the old address opens it with the
   same query. */
export const Route = createFileRoute("/_console/p/$org/$project/library/semantic")({
  validateSearch: parseSemanticSearch,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/p/$org/$project/library/search",
      params: { org: params.org, project: params.project },
      search,
      replace: true,
    });
  },
});
